import { render, staticRenderFns } from "./SpecialistArchive.vue?vue&type=template&id=1568fe9a"
import script from "./SpecialistArchive.vue?vue&type=script&lang=js"
export * from "./SpecialistArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports